import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import pic2 from "../src/assets/images/pic2.jpg";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false); // State for mobile menu

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMouseEnter = (dropdown) => {
    setActiveDropdown(dropdown);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // This makes the scroll animated
    });
  };
  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggle the mobile menu visibility
  };

  return (
    <div className="relative">
      <nav
//         className={`fixed top-0 left-0 w-full z-50 shadow-md text-white transition-all duration-900 ${
//   scrolled ? "bg-gradient-to-r from-white to-[#061e4a] shadow-lg" : "bg-gradient-to-r from-white to-[#07276f]"
// }`}
// className={`fixed top-0 left-0 w-full z-50 shadow-md text-white transition-all duration-500 ${
//   scrolled
//     ? "bg-[linear-gradient(to_right,_white_0%,_#d6e4f7_25%,_#061e4a_60%,_#061e4a_100%)] shadow-lg"
//     : "bg-[linear-gradient(to_right,_white_0%,_#d6e4f7_25%,_#07276f_60%,_#07276f_100%)]"
// }`}
// className={`fixed top-0 left-0 w-full z-50 shadow-md text-white transition-all duration-500 ${
//   scrolled
//     ? "bg-[linear-gradient(to_right,_white_0%,_#d6e4f7_18%,_#061e4a_55%,_#061e4a_100%)] shadow-lg"
//     : "bg-[linear-gradient(to_right,_white_0%,_#d6e4f7_18%,_#07276f_55%,_#07276f_100%)]"
// }`}
className={`fixed top-0 left-0 w-full z-50 shadow-md text-white transition-all duration-500 ${
  scrolled
    ? "bg-[linear-gradient(to_right,_#f9fbff_0%,_#d6e4f7_15%,_#061e4a_50%,_#061e4a_100%)] shadow-lg"
    : "bg-[linear-gradient(to_right,_#f9fbff_0%,_#d6e4f7_15%,_#07276f_50%,_#07276f_100%)]"
}`}




      >
        <div className="container mx-auto px-4 flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex flex-col items-center justify-center h-screen">
            <Link to="/" className="flex items-center">
              <img src={pic2} alt="24/7 Consultancy" className="h-12" />
              <div className="ml-3 text-center">
                {/* <div className="font-bold">Right On Time</div> */}
                {/* <div className="font-bold">Services</div> */}
                {/* <div className="text-xs">ESIC PVT LTD</div> */}
              </div>
            </Link>
          </div>

          {/* Main Menu */}
          <div className="hidden lg:flex items-center space-x-10">
            <Link
              to="/"
              className="font-medium py-7 border-b-2 border-transparent hover:border-white transition-all"
            >
              Home
            </Link>

            {/* About Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("about")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className={`font-medium py-7 flex items-center focus:outline-none border-b-2 ${
                  activeDropdown === "about"
                    ? "border-white"
                    : "border-transparent"
                } hover:border-white transition-all`}
              >
                About
                <svg
                  className="w-4 h-4 ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>

              {activeDropdown === "about" && (
                <div className="absolute left-0 mt-0 w-64 bg-white shadow-lg rounded-b-lg text-gray-800 z-50">
                  <Link
                    to="/our-expertise"
                    className="block px-6 py-3 hover:bg-gray-100"
                  >
                    Our Expertise
                  </Link>
                  <Link
                    to="/right-time-success"
                    className="block px-6 py-3 hover:bg-gray-100"
                  >
                    About Right on Time Services
                  </Link>
                </div>
              )}
            </div>

            {/* Our Business Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("business")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className={`font-medium py-7 flex items-center focus:outline-none border-b-2 ${
                  activeDropdown === "business"
                    ? "border-white"
                    : "border-transparent"
                } hover:border-white transition-all`}
              >
                Our Business
                <svg
                  className="w-4 h-4 ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>

              {activeDropdown === "business" && (
                <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 w-[800px] bg-white shadow-lg rounded-b-lg z-50">
                  <div className="grid grid-cols-4 gap-0">
                    {/* Left Blue Section */}
                    <div className="bg-[#193796] p-8 flex flex-col justify-center items-center text-white text-center">
                      {/* <img src="/logo-icon.png" alt="24/7" className="h-16 w-16 mb-4" /> */}
                      <h3 className="font-semibold text-lg mb-2">
                        Building a Better
                      </h3>
                      <h3 className="font-semibold text-lg mb-1">Business</h3>
                      <h3 className="font-semibold text-lg">World</h3>
                    </div>

                    {/* BPO Section */}
                    <div className="p-6">
                      <h3 className="font-bold text-[#193796] text-xl mb-4">
                        BPO
                      </h3>
                      <ul className="space-y-3">
                        <li>
                          <Link
                            to="/bpo"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            BPO
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/inbound"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Inbound Calls
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/outbound"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Outbound Calls
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/email-support"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Email and Chat Support
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/sms-support"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            SMS Support
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* Healthcare Section */}
                    <div className="p-6">
                      <h3 className="font-bold text-[#193796] text-xl mb-4">
                        Health Care
                      </h3>
                      <ul className="space-y-3">
                        <li>
                          <Link
                            to="/healthcare"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Healthcare solutions
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/medical-billing"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Medical Billing
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/medical-transcription"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Medical Transcriptions
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/excellence"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Management Services
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* Digital Marketing Section */}
                    <div className="p-6">
                      <h3 className="font-bold text-[#193796] text-xl mb-4">
                        Digital Marketing
                      </h3>
                      <ul className="space-y-3">
                        <li>
                          <Link
                            to="/web"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Web Development
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/graphics"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Graphics Designing
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/uiux"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            UI UX Designing
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/seo"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Search Engine Optimization
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/social"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Social Media Marketing
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/content"
                            className="text-gray-700 hover:text-[#193796]"
                          >
                            Content Writing
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/itservice"
              className="font-medium py-7 border-b-2 border-transparent hover:border-white transition-all"
            >
              IT Services
            </Link>
          </div>

          {/* Book A Meeting Button */}
          <div className="hide-btn">
            <Link to="/bookmeeting" onClick={scrollToTop}>
              <button className="px-6 py-2 border-2 border-white text-white hover:bg-white hover:text-[#07276f] transition-all rounded flex items-center">
                Book A Meeting
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  />
                </svg>
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          {/* Hamburger Icon for Mobile */}
          <button className="lg:hidden" onClick={toggleMenu}>
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div
          className="lg:hidden fixed top-0 left-0 w-full h-screen bg-[#07276f] flex bg-opacity-90 items-center justify-center text-white z-40"
          onClick={() => setMenuOpen(false)}
        >
          <div className="grid grid-cols-2 gap-4 text-center">
            {/* Left Column */}
            <div className="flex flex-col">
              <Link
                to="/"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/our-expertise"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Our Expertise
              </Link>
              <Link
                to="/right-time-success"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                About Right on Time Services
              </Link>
              <Link
                to="/bpo"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                BPO
              </Link>
              <Link
                to="/inbound"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Inbound Calls
              </Link>
              <Link
                to="/outbound"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Outbound Calls
              </Link>
              <Link
                to="/email-support"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Email & Chat Support
              </Link>
              <Link
                to="/sms-support"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                SMS Support
              </Link>
              <Link
                to="/healthcare"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Healthcare Sol.
              </Link>
              <Link
                to="/medical-billing"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Medical Billing
              </Link>
            </div>

            {/* Right Column */}
            <div className="flex flex-col">
              <Link
                to="/medical-transcription"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Medical Transcriptions
              </Link>
              <Link
                to="/excellence"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Management Services
              </Link>
              <Link
                to="/web"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Web Development
              </Link>
              <Link
                to="/graphics"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Graphic Designing
              </Link>
              <Link
                to="/uiux"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                UiUx Designing
              </Link>
              <Link
                to="/seo"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                SEO
              </Link>
              <Link
                to="/social"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Social Marketing
              </Link>
              <Link
                to="/content"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Content Writing
              </Link>
              <Link
                to="/itservice"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                IT Services
              </Link>
              <Link
                to="/bookmeeting"
                className="py-3 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Book Meeting
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
